<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.douyinId" class="input-with-select" size="small">
                        <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                            <el-option label="达人抖音号" :value="1"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.cpsType" placeholder="请选择" size="small">
                        <el-option label="不限制通用/定向" value=""></el-option>
                        <el-option label="仅看通用计划" :value="0"></el-option>
                        <el-option label="仅看定向计划" :value="1"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.sortType" placeholder="请选择" size="small">
				        <el-option label="按带货 GMV 排序" :value="0"></el-option>
				        <el-option label="按总观看数排序" :value="1"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">            
            <el-button
                v-if="$utils.have('/activity/cps/downloadTalentDataList')"
                type="primary"
                icon="el-icon-download"
                @click="download"
                size="small"
                :loading="downLoading"
                >导出列表</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="douyinId" label="达人抖音号" min-width="150" ></el-table-column>
                <el-table-column prop="name" label="达人昵称"></el-table-column>                
                <el-table-column prop="gmv" label="带货销售额" min-width="90"></el-table-column>
                <el-table-column prop="talentCommission" label="达人佣金"></el-table-column>
                <el-table-column prop="usedGmv" label="已核销订单金额" min-width="100"></el-table-column>				
				<el-table-column prop="cpsNum" label="参加计划数"></el-table-column>
				<el-table-column prop="playNum" label="总观看数"></el-table-column>
				<el-table-column prop="playVideoNum" label="观看数-短视频"></el-table-column>
				<el-table-column prop="playLiveNum" label="观看数-直播"></el-table-column>				
				<el-table-column prop="contributeNum" label="投稿数">
					<template slot-scope="scope">
						<span v-if="scope.row.contributeVideoNum || scope.row.contributeVideoNum >= 0 && scope.row.contributeLiveNum || scope.row.contributeLiveNum >= 0">
							{{scope.row.contributeVideoNum + scope.row.contributeLiveNum}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="contributeVideoNum" label="投稿数-短视频"></el-table-column>
				<el-table-column prop="contributeLiveNum" label="投稿数-直播"></el-table-column>				
                <el-table-column prop="cutOffTime" label="数据累计截止日期" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/activity/cps/downloadTalentDataDetail')"
                            type="text"
                            size="small"
                            @click="downloadUser(scope.row.douyinId)"
                            >导出明细</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <cps-edit ref="cpsEdit" @onUpdate="getDataList"></cps-edit>
    </div>
</template>
<script>
import CpsEdit from  "./components/CpsEdit.vue"
const defaultParams = {
    pageNo: 1,
    cpsType: "",
    sortType: 0,
    douyinId: ""
}
export default {
    components:{
        CpsEdit
    },
    data(){
        return{
            data: null,
            dataList: null,
			searchType:1,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                status: parseInt(this.$route.query.status) || "",
            },
            listLoading: true,
            downLoading:false,
        }
    },
    computed:{
       
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/cps/talentDataList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出列表
        download(){
            this.downLoading = true;
            this.$request({
                url: "/activity/cps/downloadTalentDataList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
		downloadUser(id){		    
		    this.$request({
		        url: "/activity/cps/downloadTalentDataDetail",
		        method: "POST",
		        params: {
		            douyinId:id
		        },
		    })
		        .then((res) => {
		            const { state, msg } = res.data;
		            if (state == 1 ) {
		                this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
		                    confirmButtonText: '立即查看',
		                    cancelButtonText: '稍后再看',
		                    type: 'success',
		                    center: true,
		                    closeOnClickModal: false
		                }).then(() => {
		                    this.$router.push({path:'/workbench/downloadList'})
		                }).catch(() => {})
		            } else {
		                this.$message.error(msg || "请求失败");
		            }
		        })
		        .catch(() => {
		            this.$message.error("请求错误");
		        })
		        
		},
        
    }
}
</script>
<style lang="scss" scoped>

</style>